import { render, staticRenderFns } from "./PrinciplesOfDevelopment.vue?vue&type=template&id=7f88e983&scoped=true&"
import script from "./PrinciplesOfDevelopment.vue?vue&type=script&lang=js&"
export * from "./PrinciplesOfDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./PrinciplesOfDevelopment.vue?vue&type=style&index=0&id=7f88e983&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f88e983",
  null
  
)

export default component.exports